<template>   
  <b-card-text>
    <b-row class="mb-1">
      <b-col md="12">        
        <b-alert variant="warning" show v-if="parameters.freeAddTypeOperation">
          <h3>Parámetro General</h3>
          La actual configuración del sistema, permite aceptar movimientos <b>"DECLARADOS" y "NO DECLARADOS"</b> en una misma caja/cuenta, pasando por alto la configuración de cada una.
          <br>
          Deshabilitar el <b>Parámetro ID:<u>61</u></b>
        </b-alert>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col sm="6">
        <b-form-group>
          <b-form-radio-group v-model="filter.status" size="sm" buttons>
            <b-form-radio value="all" button-variant="outline-dark">Todas</b-form-radio>
            <b-form-radio value="active" button-variant="outline-success">Activas</b-form-radio>
            <b-form-radio value="inactive" button-variant="outline-danger">Inactivas</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Caja/Cuenta">
          <i class="fa fa-plus"></i> Agregar
        </b-button>
        <b-button @click="show()" type="button" variant="outline-dark" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Refrescar">
          <i class="fa fa-refresh"></i> Refrescar
        </b-button>
      </b-col>      
    </b-row>

    <b-row class="mb-3">
      <b-col md="12">
        <b-table class="mb-0 table-cash"
              responsive="sm"
              head-variant="dark"
              :hover="true"
              :small="true"
              :fixed="false"
              :items="filteredItems"
              :fields="table.fields"
              :filter="table.filter"
              :current-page="table.currentPage"
              :per-page="table.perPage"
              :busy="table.isBusy"
              v-if="filteredItems.length">

          <template v-slot:cell(id)="data">
            <span class="font-size-15">
              <b>{{ data.item.id }}</b>
            </span>            
          </template>

          <template v-slot:cell(name)="data">
            <span class="font-size-15">
              <b-icon icon="share" title="Caja/Cuenta Compartida" style="cursor: pointer;" class="mr-2" v-if="data.item.shared"></b-icon>
              <b>{{ data.item.name }}</b>
            </span>
          </template>

          <template v-slot:cell(active)="data">
            <span v-if="data.item.active" class="status-active">ACTIVA</span>
            <span v-else class="status-inactive">INACTIVA</span>
          </template>

          <template v-slot:cell(keyaccess)="data">
            <span v-if="data.item.keyaccess">
              <b>CTRL</b>+
              <b>SHIFT</b>+
              <b>{{ data.item.keyaccess }}</b>
            </span>
          </template>          

          <template v-slot:cell(nd)="data">
            <div v-if="!parameters.freeAddTypeOperation">
              <b-badge v-if="data.item.nd" variant="secondary">NO DECLARADA</b-badge>            
              <b-badge v-else variant="success">DECLARADA</b-badge>            
            </div>
            <div v-else>
              <b-badge variant="dark">AMBOS MOVIMIENTOS</b-badge>            
            </div>
          </template>          

          <template v-slot:cell(uncovered)="data">
            <b-badge v-if="data.item.uncovered" variant="success">DESCUBIERTO</b-badge>            
            <b-badge v-else variant="secondary">SIN DESCUBIERTO</b-badge>            
          </template>       

          <template v-slot:cell(only_open)="data">
            <b-badge v-if="data.item.only_open" variant="secondary">SOLO CON APERTURA</b-badge>            
            <b-badge v-else variant="success">ACEPTA SIEMPRE</b-badge>            
          </template>                 

          <template v-slot:cell(opening)="data">            
            <div v-if="data.item.only_open">
              <span v-if="data.item.opening" class="table-cash-status-open">
                <b-icon icon="unlock"></b-icon>
                ABIERTA (<span v-html="statusCash(data.item)"></span>)
              </span>            
              <span v-else class="table-cash-status-close">
                <b-icon icon="lock"></b-icon>
                CERRADA
              </span>                        
            </div>
          </template>            

          <template v-slot:cell(amount_ars)="data">                        
            <span v-if="parseFloat(data.item.total_available_ars)>=0" class="cash-text-success">
              {{Intl.NumberFormat('es-AR',{style:'currency',currency: 'ARS'}).format(data.item.total_available_ars)}}
            </span>
            <span v-else class="cash-text-danger">
              ({{Intl.NumberFormat('es-AR',{style:'currency',currency: 'ARS'}).format(data.item.total_available_ars)}})
            </span>
          </template>          

          <template v-slot:cell(f_action)="data">
            <b-dropdown right text="" size="sm" variant="outline-dark" class="pull-right"> 
              <b-dropdown-item @click="reOpenCash(data.item)" v-if="data.item.only_open && !data.item.opening && data.item.status.open">
                <b-icon icon="arrow-counterclockwise"></b-icon> ReAbrir
              </b-dropdown-item>                  
              <b-dropdown-item @click="openCash(data.item)" v-if="data.item.only_open && !data.item.opening">
                <b-icon icon="unlock"></b-icon> Abrir
              </b-dropdown-item>
              <b-dropdown-item @click="closeCash(data.item)" v-if="data.item.only_open && data.item.opening">
                <b-icon icon="lock"></b-icon> Cerrar
              </b-dropdown-item>          
              
              <b-dropdown-header>Movimientos</b-dropdown-header>   
              <b-dropdown-item @click="goDetail(data.item)">
                <b-icon icon="arrows-fullscreen"></b-icon> Ver Movimientos
              </b-dropdown-item>          

              <b-dropdown-header>Acciones</b-dropdown-header>                                                                         
              <b-dropdown-item @click="edit(data.item)">
                <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="remove(data.item)">
                <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
      </b-col>
    </b-row>
                        
    <b-row>
      <b-col>
        <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
          <i class="fa fa-angle-double-left"></i>
          Volver
        </b-button>                        
      </b-col>

      <b-col>
        <nav>
          <b-pagination class="pull-right mb-0"
                        size="sm"
                        pills=""
                        :total-rows="getRowCount(filteredItems)"
                        :per-page="table.perPage"
                        v-model="table.currentPage" />
        </nav>
      </b-col> 
    </b-row>            

    <!-- ########################### -->
    <!-- #####     MODALES     ##### -->
    <!-- ########################### -->

    <b-modal v-model="modal.form.active"
            header-bg-variant="dark"
            header-text-variant="white"
            :key="modal.form._id"
            :id="modal.form._id">                
        <div slot="modal-header" minimize>
          {{this.modal.form.title}}
        </div>

        <b-alert variant="warning" show v-if="parameters.freeAddTypeOperation">
          <h3>Parámetro General</h3>
          La actual configuración del sistema, permite aceptar movimientos <b>"DECLARADOS" y "NO DECLARADOS"</b> en una misma caja/cuenta, pasando por alto la configuración de cada una.
          <br>
          Deshabilitar el <b>Parámetro ID:<u>61</u></b>
        </b-alert>

        <b-tabs>
          <b-tab no-body title="General">
            <b-row>
              <b-col md="12">
                <b-form-group label="Nombre">
                  <b-form-input type="text"
                                  size="sm"
                                  v-model="crud.form.name"
                                  required>
                  </b-form-input>
                </b-form-group>
              </b-col>                    
              <b-col md="12">       
                <hr>
              </b-col>
              <b-col md="12" v-if="!parameters.freeAddTypeOperation">       
                <b-form-group label="Tipo" description="Si la opción se activa, los movimientos realizados, solo pueden utilizarse desde un punto de venta no declarado.">         
                  <b-form-checkbox v-model="crud.form.nd" 
                                    switch 
                                    size="sm">
                    NO DECLARADA
                  </b-form-checkbox>                      
                </b-form-group>      
              </b-col>            
              <b-col md="12">       
                <b-form-group label="Descubierto" description="Si la opción se activa, permite a la caja/cuenta quedar en descubierto.">         
                  <b-form-checkbox v-model="crud.form.uncovered" 
                                    switch 
                                    size="sm">
                    ACEPTA DESCUBIERTO
                  </b-form-checkbox>                      
                </b-form-group>      
              </b-col>            
              <b-col md="12">       
                <b-form-group label="Apertura" description="Si la opción se activa, los movimientos son aceptados solo si se hace una apertura de caja.">         
                  <b-form-checkbox v-model="crud.form.only_open" 
                                    switch 
                                    size="sm">
                    MOVIMIENTOS CON APERTURAS
                  </b-form-checkbox>                      
                </b-form-group>      
              </b-col>            
              <b-col md="12">
                <b-form-group label="Compartida" description="Si la opción se activa, la caja/cuenta esta disponible para aceptar movimientos de todos los usuarios.">
                  <b-form-checkbox v-model="crud.form.shared"
                                    switch
                                    size="sm">
                    COMPARTIDA
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab no-body title="Visualización">
            <b-row>
              <b-col md="12">
                <b-form-group label="Estado" description="Si la opción se activa, la caja/cuenta estará activa y disponible para operar.">
                  <b-form-checkbox v-model="crud.form.active"
                                    switch
                                    size="sm">
                    ACTIVA
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Mostrar en Widgets" description="Si la opción se activa, la caja/cuenta aparecerá en la vista de widgets del dashboard.">
                  <b-form-checkbox v-model="crud.form.show_in_widget"
                                    switch
                                    size="sm">
                    MOSTRAR EN WIDGETS
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Orden" description="Valor numérico para ordenar las cajas. Menor número = aparece primero.">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.order"
                                min="0"
                                step="1">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab no-body title="Accesos">
            <b-row>
              <b-col lg="12">
                <b-form-group label="Acceso Rápido" description="Este acceso permite acceder rápidamente a la caja/banco para registrar el pago en una venta. Ingresa una valor numérico entre [0-9]">
                  <b-input-group size="lg" prepend="CTRL + SHIFT + ">
                    <b-form-input type="number" v-model="crud.form.keyaccess" min="0" max="9" step="1" @input="validateKeyAccess"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>            
            </b-row>
          </b-tab>
          <b-tab no-body title="Cuenta Contable" v-if="isProcessAccounting">
            <b-row>
              <b-col lg="12">
                <FindObject render="search"
                        type="accountingAccountsImputation" 
                        @select-object="loadAccountingAccounts($event)" 
                        :valueID="crud.form.accounting_accounts_id"
                        :where="conditionAccountingAccountsFilters"/>
              </b-col>              
            </b-row>            
          </b-tab>       

        </b-tabs>  

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>          
        </div>
    </b-modal>    
  </b-card-text>                                
</template>

<script>
  import serviceAPI from './../services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'
  import Param from '@/config/parameters'
  import moment from 'moment'

  export default {
    components: {
      FindObject
    },          
    data: () => {
      return {      
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class:"align-middle", width:"4%"},
            {key: 'name', label: 'Nombre', class:"align-middle", width:"12%"},            
            {key: 'keyaccess', label: 'Acceso Rápido', class:"align-middle", width:"8%"},
            {key: 'nd', label: 'Tipo', class:"align-middle", width:"12%"},
            {key: 'uncovered', label: 'Descubierto', class:"align-middle", width:"11%"},
            {key: 'only_open', label: 'Apertura', class:"align-middle", width:"11%"},
            {key: 'opening', label: '', class:"align-middle text-right", width:"12%"},
            {key: 'active', label: 'Estado', class:"align-middle", width:"8%"},
            {key: 'amount_ars', label: 'Saldo', class:"align-middle text-right", width:"12%"},
            {key: 'f_action', label:'', class:"align-middle", width:"3%"},
          ],                    
          currentPage: 1,
          perPage: 50,
          isBusy: false,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            nd: false,
            uncovered: false,
            only_open: false,
            accounting_accounts: null,
            accounting_accounts_id: 0,
            keyaccess: '',
            shared: false,
            active: true,
            order: 0,
            show_in_widget: true
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
        modulesActive: [],
        parameters: {
          freeAddTypeOperation: false
        },
        filter: {
          status: 'active'
        }
      }
    },
    computed: {
      filteredItems() {
        if (this.filter.status === 'all') {
          return this.table.items;
        } else if (this.filter.status === 'active') {
          return this.table.items.filter(item => item.active);
        } else {
          return this.table.items.filter(item => !item.active);
        }
      },
      isProcessAccounting() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {
            status = true
          }
        })
        return status
      },
      // CONDITIONS SELECT
      conditionAccountingAccountsFilters(){
        return [
            {field: 'active', condition: true},
            {field: 'type', condition: 'Activo'}
        ];
      },              
    },
    mounted () {
      this.parameters.freeAddTypeOperation = Helper.hasParametersAccess(Param.P61)
      
      this.modulesActive = Session.getSession().auth.user.permissions.modules      
      this.show()

      this._start = true
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      this.show()  
    },      
    methods: {
      getRowCount (items) {
        return items.length
      },
      show() {        
        this.table.isBusy = true

        var result = serviceAPI.obtenerCajas()

        result.then((response) => {
          this.table.isBusy = false

          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });  
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.nd = false
        this.crud.form.uncovered = false
        this.crud.form.only_open = false
        this.crud.form.accounting_accounts = null
        this.crud.form.accounting_accounts_id = 0
        this.crud.form.keyaccess = ''
        this.crud.form.shared = false
        this.crud.form.active = true
        this.crud.form.order = 0
        this.crud.form.show_in_widget = false

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Caja/Cuenta"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.nd = item.nd
        this.crud.form.uncovered = item.uncovered
        this.crud.form.only_open = item.only_open
        this.crud.form.accounting_accounts = item.accounting_accounts
        this.crud.form.accounting_accounts_id = item.accounting_accounts_id
        this.crud.form.keyaccess = item.keyaccess
        this.crud.form.shared = item.shared
        this.crud.form.active = item.active
        this.crud.form.order = item.order
        this.crud.form.show_in_widget = item.show_in_widget

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Caja/Cuenta"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Concepto',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCaja(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.show()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();

        if (this.crud.form.id) {
          var result = serviceAPI.editarCaja(this.crud.form);
        } else {
          var result = serviceAPI.agregarCaja(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.show()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      loadAccountingAccounts (object) {
        if(object){
          this.crud.form.accounting_accounts = object
          this.crud.form.accounting_accounts_id = object.id             
        } else {
          this.crud.form.accounting_accounts = null
          this.crud.form.accounting_accounts_id = 0
        }
      },      

      openCash(data) {
        this.$bvModal.msgBoxConfirm('Se abrirá la caja ' + data.name + '. ¿Desea continuar?', {
          title: 'Apertura de Caja',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'ABRIR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {          

            let loader = this.$loading.show();
            
            let result = serviceAPI.abrirCaja({
              "finances_cash_id": data.id
            });
            
            result.then((response) => {          
              loader.hide()
              this.show()
              this.$awn.success("Caja/Cuenta ABIERTA");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })              
      },
      closeCash(data) {
        this.$bvModal.msgBoxConfirm('Se cerrará la caja ' + data.name + '. ¿Desea continuar?', {
          title: 'Cierre de Caja',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'CERRAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {           
            let loader = this.$loading.show();
            
            let result = serviceAPI.cerrarCaja({
              "finances_cash_id": data.id
            });
            
            result.then((response) => {          
              loader.hide()
              this.show()
              this.$awn.success("Caja/Cuenta CERRADA");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })         
      },
      reOpenCash(data) {        
        this.$bvModal.msgBoxConfirm('Este procedimiento, reabrirá el último cierre realizado en la caja/cuenta ' + data.name + '. ¿Desea continuar?', {
          title: 'Reapertura de Caja',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'REABRIR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {          

            let loader = this.$loading.show();
            
            let result = serviceAPI.reAbrirCaja({
              "finances_cash_id": data.id
            });
            
            result.then((response) => {          
              loader.hide()
              this.show()
              this.$awn.success("Caja/Cuenta REABIERTA");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })              
      },

      statusCash(data) {
        let status = ''
        
        if(data.status.status == 'OPEN') {
          if(data.status.open) {
            status = moment(data.status.open).locale('es').fromNow()
          } else {
            status = moment().locale('es').fromNow()
          }
          
        }

        return status       
      },

      goDetail(data) {        
        this.$router.push({ 
          name: 'FinancesStaffCashDetail', 
          params: {
            finances_cash_id: data.id,
            date_start: data.status.open ? data.status.open : null,
          } 
        })
      },

      validateKeyAccess() {
        const value = this.crud.form.keyaccess;

        if (value < 0 || value > 9) {
          this.crud.form.keyaccess = '';
        }
      },      
    } 
  }
</script>
<style scoped>
  .cash-text-success {
    color:green;    
    font-size: 15px;
    font-weight: bold;
  }
  .cash-text-danger {
    color:red;
    font-size: 15px;
    font-weight: bold;
  }
  .table-cash .badge {
    font-size: 15px;
  }
  .font-size-15 {
    font-size: 15px;
  }
  .table-cash-status-open {
    font-weight: bold;
    font-size: 18px;
    color:orangered;    
  }
  .table-cash-status-close {
    font-weight: bold;
    font-size: 18px;
  }
  .status-active {
    color: #28a745;
    font-weight: bold;
    font-size: 15px;
  }
  .status-inactive {
    color: #dc3545;
    font-weight: bold;
    font-size: 15px;
  }
</style>